// extracted by mini-css-extract-plugin
module.exports = {"root":"Small_root__18f_N","upload":"Small_upload__1MrrT","imageWrap":"Small_imageWrap__14Wd6","removeBtn":"Small_removeBtn__1SO1V"};